/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const IceCreamIconConfig = {
  name: 'IceCreamIcon',
  height: 512,
  width: 448,
  svgPath: 'M368 160h-.94a144 144 0 1 0-286.12 0H80a48 48 0 0 0 0 96h288a48 48 0 0 0 0-96zM195.38 493.69a31.52 31.52 0 0 0 57.24 0L352 288H96z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(IceCreamIconConfig);
//# sourceMappingURL=ice-cream-icon.js.map